import { Result, Spin } from 'antd';
import { type ComponentType, lazy, Suspense } from 'react';

import Calendar from '../routes/Calendar/Calendar';
import CardTransactionCalculation from '../routes/CardTransactionCalculation/CardTransactionCalculation';
import CardTransactionLedger from '../routes/CardTransactionLedger/CardTransactionLedger';
import CashBatches from '../routes/CashBatches/CashBatches';
import CashTransactions from '../routes/CashTransactions/CashTransactions';
import ClassLunchCorrections from '../routes/ClassLunchCorrections/ClassLunchCorrections';
import ClassPayment from '../routes/ClassPayment/ClassPayment';
import ClubBilling from '../routes/ClubBilling/ClubBilling';
import ClubRegistration from '../routes/ClubRegistration/ClubRegistration';
import CompetitionParticipants from '../routes/Competition/CompetitionParticipants';
import CompetitionScores from '../routes/Competition/CompetitionScores';
import ParticipantImport from '../routes/Competition/ParticipantImport';
import Invoices from '../routes/Invoices/Invoices';
import ManagedClassLunch from '../routes/ManagedClassLunch/ManagedClassLunch';
import ManagedClassStudents from '../routes/ManagedClassStudents/ManagedClassStudents';
import MealQrPrinting from '../routes/MealQrPrinting/MealQrPrinting';
import MobileApps from '../routes/MobileApps/MobileApps';
import StudentImport from '../routes/StudentImport/StudentImport';
import StudentLinkQrPrinting from '../routes/StudentLinkQrPrinting/StudentLinkQrPrinting';
import TeacherMealQrPrinting from '../routes/TeacherMealQrPrinting/TeacherMealQrPrinting';

// Lazy, so Chart.js only downloads when the dashboard opens.
const ClubDashboardPage = lazy(() => import('../routes/ClubDashboard/ClubDashboard'));
const ClubDashboard = () => (
  <Suspense fallback={<Spin />}>
    <ClubDashboardPage />
  </Suspense>
);

const LunchDashboardPage = lazy(() => import('../routes/LunchDashboard/LunchDashboard'));
const LunchDashboard = () => (
  <Suspense fallback={<Spin />}>
    <LunchDashboardPage />
  </Suspense>
);

const IncomeTransactions = () => (
  <CardTransactionLedger transactionType="credit" title="Орлогын гүйлгээ" />
);

const ExpenseTransactions = () => (
  <CardTransactionLedger transactionType="debit" title="Зарлагын гүйлгээ" />
);

// The kitchen_orders screen only grants the kitchen iPad app its permission
// and is in no menu; opened on the web it just points to the app.
const KitchenOrders = () => (
  <Result status="info" title="Гал тогооны захиалгыг iPad аппаас ашиглана уу." />
);

// kitchen_headcount and kitchen_menu likewise only grant the tuck shop app its
// permissions.
const KitchenApp = () => <Result status="info" title="Цайны газрын аппаас ашиглана уу." />;

// Custom Screen components, by the `component` a custom Screen names
// (apps/server/src/screens/*.screen.ts). ScreenRenderer renders them at
// /apps/<app>/<screen>.
export const customScreenComponents: Record<string, ComponentType> = {
  calendar: Calendar,
  'card-transaction-calculation': CardTransactionCalculation,
  'cash-batches': CashBatches,
  'cash-transactions': CashTransactions,
  'class-lunch-corrections': ClassLunchCorrections,
  'class-payment': ClassPayment,
  'club-billing': ClubBilling,
  'club-dashboard': ClubDashboard,
  'club-registration': ClubRegistration,
  'competition-participant-import': ParticipantImport,
  'competition-participants': CompetitionParticipants,
  'competition-scores': CompetitionScores,
  'expense-transactions': ExpenseTransactions,
  'income-transactions': IncomeTransactions,
  invoices: Invoices,
  'kitchen-app': KitchenApp,
  'kitchen-orders': KitchenOrders,
  'mobile-apps': MobileApps,
  'lunch-dashboard': LunchDashboard,
  'managed-class-lunch': ManagedClassLunch,
  'managed-class-students': ManagedClassStudents,
  'meal-qr-printing': MealQrPrinting,
  'student-import': StudentImport,
  'student-link-qr-printing': StudentLinkQrPrinting,
  'teacher-meal-qr-printing': TeacherMealQrPrinting,
};
